import React from 'react'
import AdminHeader from '../components/AdminHeader.js'
import DashboardFooter from '../components/DashboardFooter.js'
import { Outlet } from 'react-router-dom'

function Admin() {
  return (
    <div className='dashboard-container'>
    <AdminHeader />
    <Outlet />
    <DashboardFooter />
</div>
  )
}

export default Admin